import React from 'react';
import { useAuth } from 'context/AuthContext';
import { USER_ROLES } from 'utils/constants';
import ConsumerHomepage from './ConsumerHomepage';
import PharmacistHomepage from './PharmacistHomepage';
import ShopperHomepage from './ShopperHomepage';

const HomePage = () => {
    const { user } = useAuth();

    // Determine which homepage to render based on user role
    // Default to ConsumerHomepage if no user or unknown role
    const renderHomepage = () => {
        if (!user || !user.userRole) {
            return <ConsumerHomepage />;
        }

        switch (user.userRole) {
            case USER_ROLES.PHARMACY_ROLE:
                return <PharmacistHomepage />;
            case USER_ROLES.SHOPPER_ROLE:
                return <ShopperHomepage />;
            case USER_ROLES.CONSUMER_ROLE:
            default:
                return <ConsumerHomepage />;
        }
    };

    return renderHomepage();
}

export default HomePage;
